var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"user-profile"},[_c('div',{staticClass:"primary--text mb-4 text-h5"},[_vm._v("Moje údaje")]),_c('div',{staticClass:"primary--text"},[_vm._v(" "+_vm._s(_vm.user.billingInformation.fullName)+" ")]),_c('div',{staticClass:"primary--text"},[_vm._v(" "+_vm._s(_vm.user.email)+" ")])])
}
var staticRenderFns = []

export { render, staticRenderFns }